/* Initialise the public review dropdown; retain every visitor sorting choice. */
(() => {
  const initialised = new WeakSet();
  const labels = {
    created_at: 'Newest first',
    highest_rating: 'Highest rated',
    lowest_rating: 'Lowest rated',
    with_pictures: 'Photos only',
    pictures_first: 'Photos first',
    videos_first: 'Videos first',
    most_helpful: 'Most helpful'
  };
  const initialise = () => {
    document.querySelectorAll('.anivault-reviews .jm-review-widget').forEach(widget => {
      const select = widget.querySelector('.jm-sort-filter__select');
      if (!select || select.disabled) return;
      Array.from(select.options).forEach(option => {
        if (labels[option.value] && option.textContent !== labels[option.value]) {
          option.textContent = labels[option.value];
        }
      });
      if (initialised.has(widget) || !Array.from(select.options).some(option => option.value === 'highest_rating')) return;
      initialised.add(widget);
      if (select.value !== 'highest_rating') {
        select.value = 'highest_rating';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };
  const mount = () => {
    initialise();
    document.querySelectorAll('.anivault-reviews').forEach(section => {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; initialise(); });
      }).observe(section, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
